import { SettingsSelector } from './types';

export const settingsSelector = (store: SettingsSelector) => store.settings;

export const resOptionsSelector = (store: SettingsSelector) =>
  store.settings.resOptions;
